/*! Albatross (C) GrandPad, Inc */

import * as verify_email_html from './verify_email.html';
import Vue from 'vue';

export default Vue.extend({

	render: verify_email_html.render,
	staticRenderFns: verify_email_html.staticRenderFns,

	components: {
		'gp-nav-buttons': () => import('../../shared/components/nav-buttons')
	},

	props: {
		email: String
	},

	data: function ()
	{
		return {
			resendClicked: false
		};
	},

	watch: {},

	methods: {
		onClickBack: function ()
		{
			this.$emit('back');
		},

		onClickResendEmail: function ()
		{
			this.resendClicked = true;
			this.$emit('resendEmail');
		}
	}
});
